import { type QueryKey, useQueryClient } from 'react-query';

import { useQuery } from 'src/core/api/hooks/useQuery';
import { type QueryState } from 'src/core/api/queryState';
import { reshapeApprovalScheme } from 'src/core/modules/approval-by-dimensions/hooks/reshape-approval-scheme';

import {
  type ApprovalSchemeApi,
  type ApprovalScheme,
} from '../../structure/approval-flows';

export { type ApprovalScheme } from '../../structure/approval-flows';

const getApprovalSchemeByCostCenterIdQueryKey = (
  costCenterId: string,
): QueryKey => {
  return ['approval-scheme', 'by-owner', costCenterId];
};

export const useApprovalSchemeByCostCenterIdQuery = (
  costCenterId: string,
): QueryState<ApprovalScheme> => {
  return useQuery<ApprovalScheme>({
    key: getApprovalSchemeByCostCenterIdQueryKey(costCenterId),
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: `/approval-scheme/by-owner?type=costCenter&id=${costCenterId}`,
    },
    reshapeData: (scheme: ApprovalSchemeApi): ApprovalScheme =>
      reshapeApprovalScheme(scheme),
  });
};

export const useInvalidateApprovalSchemeByCostCenterIdQuery = (): ((
  costCenterId: string,
) => Promise<void>) => {
  const queryClient = useQueryClient();

  return async (costCenterId: string): Promise<void> => {
    await queryClient.invalidateQueries<ApprovalScheme>(
      getApprovalSchemeByCostCenterIdQueryKey(costCenterId),
    );
  };
};
